import React from 'react';
import styled from 'styled-components';

const DEFAULT_VALUE = 'Default text';

const TextSectionPreview = styled.div`
  word-break: break-word;

  a {
    text-decoration: underline;
  }
  b {
    font-family: ralewayBold;
  }
`;

export const createTextComponentPreview = () => {
  return (
    <TextSectionPreview>
      <div>
        {DEFAULT_VALUE}
        <span
          style={{
            fontWeight: 'normal',
            fontSize: 14,
            marginLeft: 4,
            display: 'inline-block'
          }}
        >
          |
        </span>
      </div>
    </TextSectionPreview>
  );
};
